<script setup>
import { reactive, ref } from 'vue'
import useAuth from '../../store/auth.store'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const auth = useAuth()

const data = reactive({
  email: '',
  password: ''
})

const loading = ref(false)
const message = ref('')
const currentYear = new Date().getFullYear()
console.log("Current year: ", currentYear);

async function submit () {
  loading.value = true
  try {
    await auth.login({
      email: data.email,
      password: data.password
    })
  } catch (error) {
    message.value = '*Имэйл эсвэл нууц үг буруу байна!'
  } finally {
    loading.value = false
  }
}
</script>

<template lang="pug">
.auth-login.bg-grey-5
  q-layout
    q-page-container
      q-page
        div(style='height: 100vh')
          div.column.full-height.justify-center.items-center
            q-card.q-pa-sm.no-shadow.bg-grey-10(style='min-width: 400px')
              q-card-section.text-center.text-h4
                div.q-pb-md
                  //- img(src='../../assets/logo_image.png' height='50')
                  .text-white.text-h6.text-bold {{ t("auth.login.title") }}
                  .text-grey.text-caption mergen-savdag
                q-form(@submit='submit')
                  q-input.q-my-sm(
                    dark
                    outlined
                    :rules=`[ val => val && val.length || '' ]`
                    no-error-icon
                    hide-bottom-space
                    hide-hint
                    autofocus
                    color='secondary'
                    :label='t("customer.email")'
                    v-model='data.email'
                    stack-label
                  )
                  q-input.q-my-sm(
                    dark
                    outlined
                    :rules=`[ val => val && val.length || '' ]`
                    no-error-icon
                    hide-hint
                    hide-bottom-space
                    color='secondary'
                    :label='t("auth.login.password")'
                    v-model='data.password'
                    type='password'
                    stack-label
                  )
                  .text-caption.text-warning.q-my-sm.text-bold(v-if='message') {{ message }}
                  q-btn.full-width.text-bold(
                    dark
                    type='submit'
                    size='lg'
                    unelevated
                    color='primary'
                    label='Submit'
                  )
                  .text-caption.text-grey.q-mt-lg {{ t("auth.copyright") }} {{ currentYear }}
              q-inner-loading(:showing='loading' color='secondary' dark)
</template>